module.exports = "/templates/bds/public/font/46ca37c06d82099ebcfe6cbfc1d80246.ttf";